var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    height: 360,
    viewBox: "0 0 560 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #c5e0a9;\n      }\n\n      .cls-4 {\n        filter: url(#Rectangle_115);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_115",
    x: -70,
    y: -70,
    width: 770,
    height: 570,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 35,
    dy: 35,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115-2",
    "data-name": "Rectangle 115",
    className: "cls-1",
    width: 560,
    height: 360,
    rx: 10,
    transform: "translate(820 843)"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    className: "cls-2",
    transform: "translate(1380 1203) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-3",
    d: "M106.854,68.207c-71.837,95.1-124.342,246.756.058,395.612l89.256-74.6C71.564,240.133,234.889,98.971,241.9,93.028L219.15,66.148C189.51,31.135,134.508,31.6,106.854,68.207Z",
    transform: "translate(658.102 739.181)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileDefault);
export default __webpack_public_path__ + "static/media/tile-default.ccdf4681f01c74e4337e6c0a98e5cc96.svg";
export { ForwardRef as ReactComponent };